module.exports = __webpack_public_path__ + "img/fondo-sala.65f4ebb6.png";